import { AccountPage as Account } from "@common/account";

// The account: who is signed in, the toolbar and Delete account. The profile
// (what a player has played and saved) is the page the header's button opens.
export default function AccountPage() {
  return (
    <div className="about-main">
      <Account />
    </div>
  );
}
